import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SvPanelComponent } from './components/sv-panel/sv-panel.component';
import { HueComponent } from './components/hue/hue.component';
import { AlphaComponent } from './components/alpha/alpha.component';
import { PresetComponent } from './components/preset/preset.component';
import { FarrisColorpickerPlusComponent } from './farris-colorpicker-plus.component';

@NgModule({
  declarations: [FarrisColorpickerPlusComponent,
    SvPanelComponent,
    HueComponent,
    AlphaComponent,
    PresetComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [FarrisColorpickerPlusComponent]
})
export class FarrisColorpickerPlusModule { }